import { useMemo } from "react";
import axios, { AxiosInstance } from "axios";
import { useAuth0 } from "@auth0/auth0-react";

const basePath = process.env.REACT_APP_API_URL || "http://localhost:5010";

export const useApi = (): AxiosInstance => {
    const { getAccessTokenSilently } = useAuth0();

    return useMemo(() => {
        const instance = axios.create({
        baseURL: basePath,
        timeout: 10000,
        headers: {
            "Content-Type": "application/json",
        },
    });

    instance.interceptors.request.use(
      async (config) => {
        const token = await getAccessTokenSilently();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    instance.interceptors.response.use(
        function onFulfilled(response) {
            return response;
        } , function onRejected(error) {
            console.error("Error calling API:", error);
            return Promise.reject(error);
        }
    );

    return instance;

  }, [getAccessTokenSilently]);
}